module.exports = __webpack_public_path__ + "img/katarina_living_room_10.72bfddcd.jpg";